<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <ul class="menu-list">
          <li v-for="item in menu">
            <a :aria-expanded="true">
              <span class="icon is-small"><i :class="['fa', item.icon]"></i></span>
              <input type="checkbox" v-model="item.checked"> {{ item.label || item.label }}
              <span class="icon is-small is-angle" v-if="item.children && item.children.length">
              <i class="fa fa-angle-down"></i>
            </span>
            </a>
            <expanding v-if="item.children && item.children.length">
              <ul>
                <li v-for="subItem in item.children">
                  <input type="checkbox" v-model="subItem.checked"> {{ subItem.label || subItem.label }}
                </li>
              </ul>
            </expanding>
          </li>
        </ul>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Expanding from 'vue-bulma-expanding'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      user_id: {
        type: Number
      }
    },
    data () {
      return {
        user: {
        },
        menu: [],
        inProgress: false,
        error: '',
        permissions: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        if (this.user_id) {
          this.loadData()
        }
      })
    },
    methods: {
      isExpanded (item) {
        return item.meta.expanded
      },
      toggle (item) {
        item.meta.expanded = !item.meta.expanded
      },
      parseMenu (data) {
        data.forEach(itens => {
          if (itens.type === 1) {
            this.menu.push(
              {
                id: itens.id,
                checked: false,
                label: itens.name,
                icon: itens.icon,
                children: [
                ]
              }
            )
          }
        })
        data.forEach(itensSub => {
          if (itensSub.type === 2) {
            this.menu.forEach(itens => {
              if (itensSub.menu_id === itens.id) {
                itens.children.push(
                  {
                    id: itensSub.id,
                    label: itensSub.name,
                    checked: false
                  }
                )
              }
            })
          }
        })
        this.context.$http.get(this.context.$store.state.config.apiURL + '/menu/' + this.user_id).then((response) => {
          this.permissions = response.data
          this.setPermissions()
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/menus').then((response) => {
          this.parseMenu(response.data)
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      setPermissions () {
        this.permissions.forEach(permission => {
          this.menu.forEach(item => {
            if (item.id === permission.id) {
              item.checked = true
            }
            item.children.forEach(subItem => {
              if (subItem.id === permission.id) {
                subItem.checked = true
              }
            })
          })
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.inProgress = true
        this.error = ''
        let permission = []
        this.menu.forEach(itens => {
          if (itens.checked === true) {
            permission.push(itens.id)
          }
          console.log(this.menu)
          itens.children.forEach(subItens => {
            if (subItens.checked === true) {
              permission.push(subItens.id)
            }
          })
        })
        this.context.$http.post(this.context.$store.state.config.apiURL + '/menu/permissions', {user: this.user_id, permissions: permission}).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The user was successfully save'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Expanding
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// UserPermissions.vue?675b3373